const TEXT_SHADOW_SIZE = [
  { label: '2 Extra small', value: '2xs' },
  { label: 'Extra small', value: 'xs' },
  { label: 'Small', value: 'sm' },
  { label: 'Medium', value: 'md' },
  { label: 'Large', value: 'lg' },
  { label: 'None', value: 'none' },
]

const SHADOW_SIZE = [
  { label: '2 Extra small', value: '2xs' },
  { label: 'Extra small', value: 'xs' },
  { label: 'Small', value: 'sm' },
  { label: 'Medium', value: 'md' },
  { label: 'Large', value: 'lg' },
  { label: 'Extra large', value: 'xl' },
  { label: '2 Extra large', value: '2xl' },
  { label: 'None', value: 'none' },
]

const UNIT_OPTIONS = [
  { label: 'Pixels', value: 'px' },
  { label: 'Rem', value: 'rem' },
  { label: 'Em', value: 'em' },
  { label: 'Viewport Width', value: 'vw' },
  { label: 'Viewport Height', value: 'vh' },
  { label: 'Percentage', value: '%' },
]

const LETTER_SPACING_SIZE = [
  { label: 'Tighter', value: 'tighter' },
  { label: 'Tight', value: 'tight' },
  { label: 'Normal', value: 'normal' },
  { label: 'Wide', value: 'wide' },
  { label: 'Wider', value: 'wider' },
  { label: 'Widest', value: 'widest' },
]

const FONT_SIZE_SIZE = [
  { label: 'Extra small', value: 'xs' },
  { label: 'Small', value: 'sm' },
  { label: 'Base', value: 'base' },
  { label: 'Large', value: 'lg' },
  { label: 'Extra large', value: 'xl' },
  { label: '2 Extra large', value: '2xl' },
  { label: '3 Extra large', value: '3xl' },
  { label: '4 Extra large', value: '4xl' },
  { label: '5 Extra large', value: '5xl' },
  { label: '6 Extra large', value: '6xl' },
  { label: '7 Extra large', value: '7xl' },
  { label: '8 Extra large', value: '8xl' },
  { label: '9 Extra large', value: '9xl' },
  { label: 'None', value: 'none' },
]

const PREDEFINED_SIZES = {
  width: [
    { label: 'Auto', value: 'auto' },
    { label: 'Full', value: 'full' },
    { label: 'Screen', value: 'screen' },
    { label: 'Fit', value: 'fit' },
    { label: '3 Extra Small', value: '3xs' },
    { label: '2 Extra Small', value: '2xs' },
    { label: 'Extra Small', value: 'xs' },
    { label: 'Small', value: 'sm' },
    { label: 'Medium', value: 'md' },
    { label: 'Large', value: 'lg' },
    { label: 'Extra Large', value: '2xl' },
    { label: '2 Extra Large', value: '2xl' },
    { label: '3 Extra Large', value: '3xl' },
    { label: '4 Extra Large', value: '4xl' },
    { label: '5 Extra Large', value: '5xl' },
    { label: '6 Extra Large', value: '6xl' },
    { label: '7 Extra Large', value: '7xl' },
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '20', value: '20' },
    { label: '50', value: '50' },
  ],
  height: [
    { label: 'Auto', value: 'auto' },
    { label: 'Full', value: 'full' },
    { label: 'Screen', value: 'screen' },
    { label: 'Min', value: 'min' },
    { label: 'Max', value: 'max' },
    { label: 'Fit', value: 'fit' },
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '20', value: '20' },
    { label: '30', value: '30' },
    { label: '40', value: '40' },
    { label: '50', value: '50' },
  ],
  padding: [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '20', value: '20' },
    { label: '30', value: '30' },
    { label: '40', value: '40' },
    { label: '50', value: '50' },
  ],
  margin: [
    { label: 'Auto', value: 'auto' },
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '10', value: '10' },
    { label: '20', value: '20' },
    { label: '30', value: '30' },
    { label: '40', value: '40' },
    { label: '50', value: '50' },
  ],
}

const HIDE_SIZES = {
  width: {
    max: ['auto'],
  },
}

const BORDER_RADIUS_SIZE = [
  { label: 'Extra small', value: 'xs' },
  { label: 'Small', value: 'sm' },
  { label: 'Medium', value: 'md' },
  { label: 'Large', value: 'lg' },
  { label: 'Extra large', value: 'xl' },
  { label: '2 Extra large', value: '2xl' },
  { label: '3 Extra large', value: '3xl' },
  { label: '4 Extra large', value: '4xl' },
  { label: 'Full', value: 'full' },
  { label: 'None', value: 'none' },
]

const UNIT_PREDEFINED_OPTIONS = [
  { label: 'Predefined', value: 'predefined' },
  ...UNIT_OPTIONS,
]

const FONT_WEIGHTS = [
  { label: 'Thin', value: 'thin' },
  { label: 'Extra Light', value: 'extralight' },
  { label: 'Light', value: 'light' },
  { label: 'Normal', value: 'normal' },
  { label: 'Medium', value: 'medium' },
  { label: 'Semi Bold', value: 'semibold' },
  { label: 'Bold', value: 'bold' },
  { label: 'Extra Bold', value: 'extrabold' },
  { label: 'Black', value: 'black' },
]

const ASPECT_RATIO = [
  { label: 'Square', value: 'square' },
  { label: 'Video', value: 'video' },
  { label: 'Auto', value: 'auto' },
]

const UTILITIES = [
  { label: 'Hover', value: 'hover', group: 'pseudo-classes' },
  { label: 'Focus', value: 'focus', group: 'pseudo-classes' },
  { label: 'Focus Within', value: 'focus-within', group: 'pseudo-classes' },
  { label: 'Focus Visible', value: 'focus-visible', group: 'pseudo-classes' },
  { label: 'Active', value: 'active', group: 'pseudo-classes' },
  { label: 'Visited', value: 'visited', group: 'pseudo-classes' },
  { label: 'Target', value: 'target', group: 'pseudo-classes' },
  { label: 'First Child', value: 'first', group: 'pseudo-classes' },
  { label: 'Last Child', value: 'last', group: 'pseudo-classes' },
  { label: 'Only Child', value: 'only', group: 'pseudo-classes' },
  { label: 'Odd Child', value: 'odd', group: 'pseudo-classes' },
  { label: 'Even Child', value: 'even', group: 'pseudo-classes' },
  { label: 'First of Type', value: 'first-of-type', group: 'pseudo-classes' },
  { label: 'Last of Type', value: 'last-of-type', group: 'pseudo-classes' },
  { label: 'Only of Type', value: 'only-of-type', group: 'pseudo-classes' },
  { label: 'Empty', value: 'empty', group: 'pseudo-classes' },
  { label: 'Disabled', value: 'disabled', group: 'pseudo-classes' },
  { label: 'Enabled', value: 'enabled', group: 'pseudo-classes' },
  { label: 'Checked', value: 'checked', group: 'pseudo-classes' },
  { label: 'Indeterminate', value: 'indeterminate', group: 'pseudo-classes' },
  { label: 'Optional', value: 'optional', group: 'pseudo-classes' },
  { label: 'Required', value: 'required', group: 'pseudo-classes' },
  { label: 'Valid', value: 'valid', group: 'pseudo-classes' },
  { label: 'Invalid', value: 'invalid', group: 'pseudo-classes' },
  { label: 'User Valid', value: 'user-valid', group: 'pseudo-classes' },
  { label: 'User Invalid', value: 'user-invalid', group: 'pseudo-classes' },
  { label: 'User Required', value: 'user-required', group: 'pseudo-classes' },
  { label: 'In Range', value: 'in-range', group: 'pseudo-classes' },
  { label: 'Out of Range', value: 'out-of-range', group: 'pseudo-classes' },
  { label: 'Placeholder Shown', value: 'placeholder-shown', group: 'pseudo-classes' },
  { label: 'Details Content', value: 'details-content', group: 'pseudo-classes' },
  { label: 'Autofill', value: 'autofill', group: 'pseudo-classes' },
  { label: 'Read Only', value: 'read-only', group: 'pseudo-classes' },

  { label: 'Group Hover', value: 'group-hover', group: 'group' },
  { label: 'Group Focus', value: 'group-focus', group: 'group' },
  { label: 'Group Focus Within', value: 'group-focus-within', group: 'group' },
  { label: 'Group Focus Visible', value: 'group-focus-visible', group: 'group' },
  { label: 'Group Active', value: 'group-active', group: 'group' },
  { label: 'Group Visited', value: 'group-visited', group: 'group' },
  { label: 'Group Target', value: 'group-target', group: 'group' },
  { label: 'Group First Child', value: 'group-first', group: 'group' },
  { label: 'Group Last Child', value: 'group-last', group: 'group' },
  { label: 'Group Only Child', value: 'group-only', group: 'group' },
  { label: 'Group Odd Child', value: 'group-odd', group: 'group' },
  { label: 'Group Even Child', value: 'group-even', group: 'group' },
  { label: 'Group First of Type', value: 'group-first-of-type', group: 'group' },
  { label: 'Group Last of Type', value: 'group-last-of-type', group: 'group' },
  { label: 'Group Only of Type', value: 'group-only-of-type', group: 'group' },
  { label: 'Group Empty', value: 'group-empty', group: 'group' },
  { label: 'Group Disabled', value: 'group-disabled', group: 'group' },
  { label: 'Group Enabled', value: 'group-enabled', group: 'group' },
  { label: 'Group Checked', value: 'group-checked', group: 'group' },
  { label: 'Group Indeterminate', value: 'group-indeterminate', group: 'group' },
  { label: 'Group Default', value: 'group-default', group: 'group' },
  { label: 'Group Optional', value: 'group-optional', group: 'group' },
  { label: 'Group Required', value: 'group-required', group: 'group' },
  { label: 'Group Valid', value: 'group-valid', group: 'group' },
  { label: 'Group Invalid', value: 'group-invalid', group: 'group' },
  { label: 'Group User Invalid', value: 'group-user-invalid', group: 'group' },
  { label: 'Group User Required', value: 'group-user-required', group: 'group' },
  { label: 'Group In Range', value: 'group-in-range', group: 'group' },
  { label: 'Group Out of Range', value: 'group-out-of-range', group: 'group' },
  { label: 'Group Placeholder Shown', value: 'group-placeholder-shown', group: 'group' },
  { label: 'Group Details Content', value: 'group-details-content', group: 'group' },
  { label: 'Group Autofill', value: 'group-autofill', group: 'group' },
  { label: 'Group Read Only', value: 'group-read-only', group: 'group' },

  { label: 'Peer Hover', value: 'peer-hover', group: 'peer' },
  { label: 'Peer Focus', value: 'peer-focus', group: 'peer' },
  { label: 'Peer Focus Within', value: 'peer-focus-within', group: 'peer' },
  { label: 'Peer Focus Visible', value: 'peer-focus-visible', group: 'peer' },
  { label: 'Peer Active', value: 'peer-active', group: 'peer' },
  { label: 'Peer Visited', value: 'peer-visited', group: 'peer' },
  { label: 'Peer Target', value: 'peer-target', group: 'peer' },
  { label: 'Peer First Child', value: 'peer-first', group: 'peer' },
  { label: 'Peer Last Child', value: 'peer-last', group: 'peer' },
  { label: 'Peer Only Child', value: 'peer-only', group: 'peer' },
  { label: 'Peer Odd Child', value: 'peer-odd', group: 'peer' },
  { label: 'Peer Even Child', value: 'peer-even', group: 'peer' },
  { label: 'Peer First of Type', value: 'peer-first-of-type', group: 'peer' },
  { label: 'Peer Last of Type', value: 'peer-last-of-type', group: 'peer' },
  { label: 'Peer Only of Type', value: 'peer-only-of-type', group: 'peer' },
  { label: 'Peer Empty', value: 'peer-empty', group: 'peer' },
  { label: 'Peer Disabled', value: 'peer-disabled', group: 'peer' },
  { label: 'Peer Enabled', value: 'peer-enabled', group: 'peer' },
  { label: 'Peer Checked', value: 'peer-checked', group: 'peer' },
  { label: 'Peer Indeterminate', value: 'peer-indeterminate', group: 'peer' },
  { label: 'Peer Default', value: 'peer-default', group: 'peer' },
  { label: 'Peer Optional', value: 'peer-optional', group: 'peer' },
  { label: 'Peer Required', value: 'peer-required', group: 'peer' },
  { label: 'Peer Valid', value: 'peer-valid', group: 'peer' },
  { label: 'Peer Invalid', value: 'peer-invalid', group: 'peer' },
  { label: 'Peer User Invalid', value: 'peer-user-invalid', group: 'peer' },
  { label: 'Peer User Required', value: 'peer-user-required', group: 'peer' },
  { label: 'Peer In Range', value: 'peer-in-range', group: 'peer' },
  { label: 'Peer Out of Range', value: 'peer-out-of-range', group: 'peer' },
  { label: 'Peer Placeholder Shown', value: 'peer-placeholder-shown', group: 'peer' },
  { label: 'Peer Details Content', value: 'peer-details-content', group: 'peer' },
  { label: 'Peer Autofill', value: 'peer-autofill', group: 'peer' },
  { label: 'Peer Read Only', value: 'peer-read-only', group: 'peer' },

  { label: 'small (640px)', value: 'sm', group: 'screen size' },
  { label: 'medium (768px)', value: 'md', group: 'screen size' },
  { label: 'large (1024px)', value: 'lg', group: 'screen size' },
  { label: 'extra large (1280px)', value: 'xl', group: 'screen size' },
  { label: '2 extra large (1536px)', value: '2xl', group: 'screen size' },

  { label: 'Before', value: 'before', group: 'pseudo-elements' },
  { label: 'After', value: 'after', group: 'pseudo-elements' },
  { label: 'First Line', value: 'first-line', group: 'pseudo-elements' },
  { label: 'First Letter', value: 'first-letter', group: 'pseudo-elements' },
  { label: 'File', value: 'file', group: 'pseudo-elements' },
  { label: 'Selection', value: 'selection', group: 'pseudo-elements' },
  { label: 'Backdrop', value: 'backdrop', group: 'pseudo-elements' },

  { label: 'Aria Busy', value: 'aria-busy', group: 'aria' },
  { label: 'Aria Checked', value: 'aria-checked', group: 'aria' },
  { label: 'Aria Disabled', value: 'aria-disabled', group: 'aria' },
  { label: 'Aria Expanded', value: 'aria-expanded', group: 'aria' },
  { label: 'Aria Hidden', value: 'aria-hidden', group: 'aria' },
  { label: 'Aria Pressed', value: 'aria-pressed', group: 'aria' },
  { label: 'Aria Readonly', value: 'aria-readonly', group: 'aria' },
  { label: 'Aria Required', value: 'aria-required', group: 'aria' },
  { label: 'Aria Selected', value: 'aria-selected', group: 'aria' },

  { label: 'Inert', value: 'inert', group: 'others' },
  { label: 'First Of Type', value: 'first-of-type', group: 'others' },
  { label: 'Last Of Type', value: 'last-of-type', group: 'others' },
  { label: 'Only Of Type', value: 'only-of-type', group: 'others' },
  { label: 'Empty', value: 'empty', group: 'others' },
  { label: 'Motion Safe', value: 'motion-safe', group: 'others' },
  { label: 'Motion Reduce', value: 'motion-reduce', group: 'others' },
  { label: 'Contrast More', value: 'contrast-more', group: 'others' },
  { label: 'Contrast Less', value: 'contrast-less', group: 'others' },
  { label: 'Forced Colors', value: 'forced-colors', group: 'others' },
  { label: 'Inverted Colors', value: 'inverted-colors', group: 'others' },
  { label: 'Pointer Fine', value: 'pointer-fine', group: 'others' },
  { label: 'Pointer Coarse', value: 'pointer-coarse', group: 'others' },
  { label: 'Pointer None', value: 'pointer-none', group: 'others' },
  { label: 'Any Pointer Fine', value: 'any-pointer-fine', group: 'others' },
  { label: 'Any Pointer Coarse', value: 'any-pointer-coarse', group: 'others' },
  { label: 'Any Pointer None', value: 'any-pointer-none', group: 'others' },
  { label: 'Portrait', value: 'portrait', group: 'others' },
  { label: 'Landscape', value: 'landscape', group: 'others' },
  { label: 'Noscript', value: 'noscript', group: 'others' },
  { label: 'Print', value: 'print', group: 'others' },
  { label: 'Open', value: 'open', group: 'others' },
  { label: 'starting', value: 'Starting', group: 'others' },

  { label: 'Status Checked', value: '[[data-status=checked]_&]', group: 'special', alias: 'Status Checked' },
  { label: 'Status Error', value: '[[data-status=error]_&]', group: 'special', alias: 'Status Error' },
]

const groups = [
  'pseudo-classes',
  'pseudo-elements',
  'group',
  'peer',
  'aria',
  'screen size',
  'others',
]

const UTILITIES_BY_GROUP = groups.map(group => ({
  category: group,
  items: UTILITIES.filter(utility => utility.group === group),
}))

const UTILITIES_FLAT = UTILITIES.map(utility => utility.value)

const UTILITIES_ALIASES = UTILITIES
  .filter(utility => utility.alias)
  .reduce((aliasesMap, utility) => {
    aliasesMap[utility.value] = utility.alias
    return aliasesMap
  }, {})

export {
  TEXT_SHADOW_SIZE,
  SHADOW_SIZE,
  UNIT_OPTIONS,
  UNIT_PREDEFINED_OPTIONS,
  LETTER_SPACING_SIZE,
  FONT_SIZE_SIZE,
  PREDEFINED_SIZES,
  BORDER_RADIUS_SIZE,
  FONT_WEIGHTS,
  UTILITIES,
  UTILITIES_BY_GROUP,
  UTILITIES_FLAT,
  UTILITIES_ALIASES,
  HIDE_SIZES,
  ASPECT_RATIO,
}
